import { Broadcaster } from '@core/app/scripts/services/broadcaster';

/*
 * Handles draggables. The dragContainer handles displaying the dragBox to the user and tracking x and y position of the mouse.
 * Assumes there's only ever one item being dragged.
 * While normally used through the draggable directive, you can also use it directly by giving a functionOnDrag parameter to the options object.
 */
angular
  .module('posApp')
  .factory(
    'dragItem',
    ($rootScope: ng.IRootScopeService, broadcaster: Broadcaster) => ({
      /**Call dragItem.drag(object, options) to start dragging around an object. This function will trigger a broadcast to alert dragContainers.
       * @param {Object or String} object The object to be dragged around
       * @param {Object} options Object with optional parameters: element, dragElement, dragHtml, functionOnDrag
       */
      drag: function (object, options) {
        this.stop();
        let e;
        let body;

        if (typeof object === 'string') {
          object = {
            label: object,
            objectType: 'draggedString',
          };
        }
        if (options.dragElement) {
          if (options.element && options.parentage != -1) {
            e = options.element[0];
            if (options.parentage) {
              for (let i = 0; i < options.parentage; i++) {
                e = e.parentNode;
              }
            }
            body = e.outerHTML;
          } else {
            body =
              '<div class="' +
              object.objectType +
              '">' +
              object.label +
              '</div>';
            if (_.isUndefined(object.label)) {
              if (_.isUndefined(object.name)) {
                body = '<div class="' + '">' + '</div>';
              } else {
                body = '<div class="' + '">' + object.name + '</div>';
              }
            }
          }
        }
        if (options.dragHtml) {
          this.html = options.dragHtml;
        } else {
          this.html = body;
        }
        this.objectType = object.objectType;
        this.draggedItem = object;
        if (options.functionOnDrag) {
          this.functionOnDrag = options.functionOnDrag;
        } else {
          this.functionOnDrag = false;
        }
        broadcaster.send('startDragging');
      },

      stop: function () {
        this.draggedItem = null;
        $rootScope.draggedItem = null;
        broadcaster.send('stopDragging');
      },

      setPosition: function (x, y) {
        this.x = x;
        this.y = y;
        if (this.functionOnDrag) {
          this.functionOnDrag(x, y);
        }
      },
    }),
  );
